import React from 'react';
import { motion } from 'framer-motion';
export function AuthorSection() {
  return <section className="bg-navy text-cream py-24 px-5 border-t border-gold/10" data-id="element-1">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-2/5" data-id="element-3">
          <div className="relative rounded-lg overflow-hidden border border-gold/20" data-id="element-4">
            <img src="https://cdn.magicpatterns.com/uploads/bg3tehQpHK8GiT2XCFaz1g/foto_pato.jpg" alt="Patricio Rapaport" className="w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-500" data-id="element-5" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="w-full md:w-3/5" data-id="element-6">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold mb-2" data-id="element-7">
            Patricio Rapaport
          </h2>
          <p className="font-dmsans text-gold uppercase tracking-widest text-sm font-bold mb-8" data-id="element-8">
            Asesor de Viajes Senior · Coach de Ventas
          </p>

          <div className="space-y-4 font-dmsans text-cream/80 leading-relaxed" data-id="element-9">
            <p data-id="element-10">
              Con más de 15 años de experiencia en la industria del turismo,
              trabajé miles de consultas reales con pasajeros, armando
              propuestas, haciendo seguimiento y cerrando ventas en el día a
              día.
            </p>
            <p data-id="element-11">
              En ese proceso fui entendiendo algo simple: muchas oportunidades
              no se pierden por el producto, sino por cómo{' '}
              <span className="text-gold font-bold" data-id="element-12">comunicamos</span> nuestras
              propuestas de viaje y cómo nos comunicamos como vendedores.
            </p>
            <p data-id="element-13">
              Este eBook no presenta una fórmula mágica ni un método inventado.
              Es una forma de trabajar: cómo ordeno la comunicación, cómo adapto
              mensajes según cada cliente y cómo encaro el seguimiento.
            </p>
            <p data-id="element-14">
              Comparto lo que utilizo todos los días, con ejemplos reales, para
              que puedas tomarlo como base y adaptarlo a tu propio estilo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}